export const bankCardHeader = {
    displayCardBalance: true,
};
